import Panel from "./Panel.js"

export default class PanelMenu extends Panel {

  constructor(props, context) {
    super(props, context)
    this.state.keyDown = false
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onKeyDown(event) {
    if (event.keyCode == 13 || event.keyCode == 32) {
      this.state.keyDown = true
      this.toggle()
    }
  }
}
